import React, { Fragment, useState } from "react";
import {
  PlusCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";
import { useFormik } from "formik";
import * as Yup from "yup";

const AdminCreditSlideOver = ({
  show,
  setShowSlide,
  handleClose,
  type,
  handleApproveDeny,
  loader
}) => {
  const validationSchema = Yup.object().shape({
    decisionComment: Yup.string().required("Decision Comment is required."),
  });

  const formik = useFormik({
    initialValues: {
      decisionComment: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleApproveDeny(values.decisionComment, type);
    },
  });

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:pt-10 md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="">
                      <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-[30px] mb-4 md:mb-6">
                        <div className="flex items-center justify-between mb-2 md:mb-5">
                          <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                            {type} Refund Request
                          </Dialog.Title>
                          <XMarkIcon
                            className="w-6 h-6 cursor-pointer text-black hover:text-red-700"
                            onClick={handleClose}
                          />
                        </div>
                        <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868]">
                          Write your reasons for approving this credit refund
                          request as necessary.
                        </p>
                      </div>
                      <form className="scroller max-h-[220px] md:max-h-[300px] overflow-y-auto pr-1 mb-[30px]">
                        <label className="text-sm md:text-lg font-bold leading-[160%] text-[#485868] mb-3 block">
                          Decision Comment
                        </label>
                        <textarea
                          id="decisionComment"
                          name="decisionComment"
                          placeholder={`${type} Refund Request`}
                          className="block w-full p-4 md:py-5 md:px-[30px] rounded-[10px] border border-strokeColor min-h-[120px] md:min-h-[170px] resize-none outline-none text-sm md:text-lg font-normal leading-[160%] text-customGray placeholder:text-[#869099]"
                          value={formik.values.decisionComment}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        ></textarea>
                        {formik.touched.decisionComment &&
                        formik.errors.decisionComment ? (
                          <div className="text-red-500 text-sm leading-[160%] font-bold mt-2">
                            {formik.errors.decisionComment}
                          </div>
                        ) : null}
                      </form>
                      <div className="grid grid-cols-1 gap-5">
                        <IconButton
                          title={type}
                          icon={type === "Deny" ? XCircleIcon : CheckCircleIcon}
                          classes={`mb-5 md:mb-0 flex items-center ${
                            type === "Deny" ? "bg-[#EF2121]" : "bg-[#16CA7C]"
                          } text-sm md:text-base rounded-[10px] text-white font-black uppercase text-[#485868] leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                          onClick={formik.handleSubmit}
                          iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                          buttonLoader={loader}
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminCreditSlideOver;
